import '../scss/products.scss';

import {
  SpinnerOverlay
} from 'application/src/js/util.js'
import ProductList from './products/product-list.js'

window.addEventListener('DOMContentLoaded', _ => {
  new ProductList({
    loader: new SpinnerOverlay({
      targetContainer: document.querySelector('.products-container .outer-list'),
      position: 'absolute'
    }),
    translations: translations.productList,
    filterProductsFn: products => products.filter(product => product.dynamic_offer_amount + product.contract_offer_amount > 0),
    baseTargetUrl: '/search?t=offers'
  });
});